import React from "react";
import { Snackbar, Alert } from "@mui/material";

interface SuccessSnackbarProps {
  open: boolean;
  handleClose: () => void;
  message: string
}

const SuccessSnackbar: React.FC<SuccessSnackbarProps> = ({ open, handleClose, message}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert onClose={handleClose} severity="success" variant="filled">
        {`${message} Successfull`}
      </Alert>
    </Snackbar>
  );
};

export default SuccessSnackbar;
